import { Modal, Switch } from "antd";
import { useTranslation } from "react-i18next";

/*
 * "In den Export übernehmen" (SMT-1366, SMT-1434).
 *
 * Default (recurring fee, SMT-1366): switching it ON asks first. While the
 * customer still has an EasyBill subscription, EasyBill bills the fee itself,
 * and exporting it as well bills the customer twice. Switching it off needs no
 * confirmation.
 *
 * `confirmOnDisable` (normal tax services, SMT-1434): the question is the other
 * way round. Switching it OFF asks first, because a service left out of the
 * export is not billed unless it was billed manually in EasyBill. Switching it
 * ON needs no confirmation.
 *
 * Used as a controlled Form.Item child (`valuePropName="checked"`).
 */
export const ExportSwitch = ({
  checked,
  onChange,
  disabled,
  confirmOnDisable,
  id,
  "data-test": dataTest,
}: {
  // Passed by Form.Item so the form label is tied to the switch.
  id?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  confirmOnDisable?: boolean;
  "data-test"?: string;
}) => {
  const { t } = useTranslation("ServiceTracker");

  const handleChange = (next: boolean) => {
    if (confirmOnDisable) {
      if (next) {
        onChange?.(true);
        return;
      }
      Modal.confirm({
        title: String(t("serviceTracker.excludeFromExportConfirm.title")),
        content: String(t("serviceTracker.excludeFromExportConfirm.content")),
        okText: String(t("serviceTracker.excludeFromExportConfirm.ok")),
        cancelText: String(t("serviceTracker.excludeFromExportConfirm.cancel")),
        onOk: () => onChange?.(false),
      });
      return;
    }

    if (!next) {
      onChange?.(false);
      return;
    }
    Modal.confirm({
      title: String(t("serviceTracker.recurringFee.exportConfirmTitle")),
      content: String(t("serviceTracker.recurringFee.exportConfirmContent")),
      okText: String(t("serviceTracker.recurringFee.exportConfirmOk")),
      cancelText: String(t("serviceTracker.recurringFee.exportConfirmCancel")),
      onOk: () => onChange?.(true),
    });
  };

  return (
    <Switch
      id={id}
      checked={!!checked}
      onChange={handleChange}
      disabled={disabled}
      data-test={dataTest}
    />
  );
};
